<template id="Funcionalidades">
  <v-ons-page id="FuncionalidadesPage">
    <v-card
      class="Card_Contain d-flex align-center flex-column"
      style="margin-bottom: 75px"
    >
      <div class="Card_Titulo">
        <h1>Funções</h1>
      </div>

      <v-row style="margin-top: 60px;">
        <v-col class="d-flex align-center" style="text-transform: none;">
          Informar login e senha do wifi no cardápio digital?
        </v-col>
        <v-col class="d-flex justify-end align-center" style="max-width: 200px;">
          <span style="margin-right: 8px">Não</span>
          <v-switch
            v-model="e.flMostrarWifi"
            flat
            input-value="0"
            color="#ffdf00"
          ></v-switch>
          <span style="margin-left: 8px">Sim</span>
        </v-col>
      </v-row>

      <v-row style="max-height: 85px; margin-bottom: 5px" v-show="e.flMostrarWifi == 1">
        <v-col class="d-flex align-baseline">
          <span style="margin-right: 10px">Nome Rede:</span>
          <v-text-field outlined v-model="e.dsNomeWifi"></v-text-field>
        </v-col>

        <v-col class="d-flex align-baseline">
          <span style="margin-right: 10px">Senha:</span>
          <v-text-field outlined  v-model="e.dsSenhaWifi"></v-text-field>
        </v-col>
        
      </v-row>

      <v-divider style="width: 50vw;"></v-divider>

      <v-row>
        <v-col class="d-flex align-center" style="text-transform: none;">
          Incluir botão de promoção?
        </v-col>
        <v-col class="d-flex justify-end align-center" style="max-width: 200px;">
          <span style="margin-right: 8px">Não</span>
          <v-switch
            v-model="e.flExibirPromocao"
            flat
            color="#ffdf00"
          ></v-switch>
          <span style="margin-left: 8px">Sim</span>
        </v-col>
      </v-row>

      <v-divider style="width: 50vw;"></v-divider>

      <v-row>
        <v-col class="d-flex align-center" style="text-transform: none;">
          Incluir botão chamar garçom?
        </v-col>
        <v-col class="d-flex justify-end align-center" style="max-width: 200px;">
          <span style="margin-right: 8px">Não</span>
          <v-switch
            v-model="e.flChamarGarcom"
            flat
            color="#ffdf00"
          ></v-switch>
          <span style="margin-left: 8px">Sim</span>
        </v-col>
      </v-row>

      <v-divider style="width: 50vw;"></v-divider>
      
      <v-row>
        <v-col class="d-flex align-center" style="text-transform: none;">
          Incluir botão pedir conta?
        </v-col>
        <v-col class="d-flex justify-end align-center" style="max-width: 200px;">
          <span style="margin-right: 8px">Não</span>
          <v-switch
            v-model="e.flPedirConta"
            flat
            color="#ffdf00"
          ></v-switch>
          <span style="margin-left: 8px">Sim</span>
        </v-col>
      </v-row>

      <v-divider style="width: 50vw;"></v-divider>

      <v-row v-show="e.flChamarGarcom  || e.flPedirConta " style="margin: 5px 0;">
        <v-col>
          <v-row class="fullWidthRow"
            ><v-col>
              <small style="color: #999; text-transform: none; margin-right: 10px">
                Este será o seu link de acesso para receber as solicitações de
                garçom e conta: </small
              ><img
                @click="showPopover($event, 0)"
                src="../assets/img/icoAjuda.png"
              /> </v-col
          ></v-row>
          <v-row class="fullWidthRow"
            ><v-col>
              <v-row class="conteudo-centro">
                <div class="d-flex align-center">
                  <a class="linkChat" target="_blank" :href="internoLink">{{
                    internoLink
                  }}</a>
                </div>
                <div>
                  <img :src="qrCodePedidos" alt="Qrcode" />
                </div>
              </v-row>
            </v-col></v-row
          >
        </v-col>
      </v-row>

      <v-divider style="width: 50vw;"></v-divider>

      <v-row style="margin-top: 10px; display: grid; grid-template-columns: 39vw 1fr;">
        <v-col style="text-transform: none; margin-left: 12px;">
          <v-row>Incluir botão de receber sugestões? </v-row>
          <v-row style="font-size: 0.75rem; margin-top: 8px">(as sugestões recebidas serão enviadas para seu email de cadastro aqui do QRService)</v-row>
        </v-col>
        <v-col class="d-flex justify-end align-center containerSwitch">
          <span style="margin-right: 8px">Não</span>
          <v-switch
            v-model="e.flEnviarMsg"
            flat
            color="#ffdf00"
          ></v-switch>
          <span style="margin-left: 8px">Sim</span>
        </v-col>
      </v-row>

      <v-row v-show="e.flEnviarMsg == 1">
        <v-col>
          <textarea
            class="textarea"
            rows="6"
            placeholder="Insira uma mensagem de agradecimento que será exibida para o cliente, quando ele enviar uma sugestão."
            v-model="e.txAgradecimento"
            style="margin: 20px 0"
          >
          </textarea>
        </v-col>
      </v-row>

      <v-divider style="width: 50vw;"></v-divider>

      <!-- Selos -->
      <v-row>
        <v-col class="d-flex align-center" style="text-transform: none;">
          Incluir selos?
        </v-col>
        <v-col class="d-flex justify-end align-center" style="max-width: 200px">
          <span style="margin-right: 8px">Não</span>
          <v-switch
            v-model="e.flAddSelo"
            flat
            color="#ffdf00"
          ></v-switch>
          <span style="margin-left: 8px">Sim</span>
        </v-col>
      </v-row>

      <v-row v-show="e.flAddSelo == 1">
        <v-col class="fullWidthRow">
          <v-row class="d-flex justify-center">
            <b-col style="margin-right: 30px">
              <img src="../assets/img/seloVeg.png" class="img-selo" />
              <v-ons-checkbox
                :input-id="'checkbox-0'"
                @click="
                  () => {
                    e.flSeloVeg = e.flSeloVeg == '1' ? 0 : 1;
                  }
                "
                :checked="e.flSeloVeg == '1'"
              ></v-ons-checkbox>
            </b-col>
            <b-col style="margin-right: 30px">
              <img src="../assets/img/seloHealthy.png" class="img-selo" />
              <v-ons-checkbox
                :input-id="'checkbox-1'"
                @click="
                  () => {
                    e.flSeloHealthy = e.flSeloHealthy == '1' ? 0 : 1;
                  }
                "
                :checked="e.flSeloHealthy == '1'"
              ></v-ons-checkbox>
            </b-col>
            <b-col style="margin-right: 30px">
              <img src="../assets/img/seloOrganic.png" class="img-selo" />
              <v-ons-checkbox
                :input-id="'checkbox-2'"
                @click="
                  () => {
                    e.flSeloOrganic = e.flSeloOrganic == '1' ? 0 : 1;
                  }
                "
                :checked="e.flSeloOrganic == '1'"
              ></v-ons-checkbox>
            </b-col>
            <b-col style="margin-right: 30px">
              <img src="../assets/img/seloPet.png" class="img-selo" />
              <v-ons-checkbox
                :input-id="'checkbox-3'"
                @click="
                  () => {
                    e.flSeloPet = e.flSeloPet == '1' ? 0 : 1;
                  }
                "
                :checked="e.flSeloPet == '1'"
              ></v-ons-checkbox>
            </b-col>
            <b-col>
              <img src="../assets/img/seloHigiene.png" class="img-selo" />
              <v-ons-checkbox
                :input-id="'checkbox-4'"
                @click="
                  () => {
                    e.flSeloHigiene = e.flSeloHigiene == '1' ? 0 : 1;
                  }
                "
                :checked="e.flSeloHigiene == '1'"
              ></v-ons-checkbox>
            </b-col>
          </v-row>
        </v-col>
      </v-row>

      <v-divider style="width: 50vw; margin: 20px 0"></v-divider>

      <v-row style="margin-top: 10px; display: grid; grid-template-columns: 39vw 1fr;">
        <v-col style="text-transform: none; margin-left: 12px;">
          <v-row>Incluir botão do dia? </v-row>
          <v-row style="font-size: 0.75rem; margin-top: 8px">(clique na lousa para editar a promoção do dia)</v-row>
        </v-col>
        <v-col class="d-flex justify-end align-center containerSwitch">
          <span style="margin-right: 8px">Não</span>
          <v-switch
            v-model="e.flExibirLousa"
            flat
            color="#ffdf00"
          ></v-switch>
          <span style="margin-left: 8px">Sim</span>
        </v-col>
      </v-row>
      
      <v-ons-row v-show="e.flExibirLousa == 1">
        <div class="lousa" @input="updateLousa" contenteditable>{{ lousaEditable }}</div>
      </v-ons-row>

      <v-ons-row>
        <v-col>
          <v-ons-button @click="salvarEstab()" class="botao"
            >Salvar Alterações</v-ons-button
          >
        </v-col>
        <v-col>
          <v-ons-button @click="openCardapio()" class="botao"
            >Visualizar Cardapio</v-ons-button
          >
        </v-col>
      </v-ons-row>
      
      <v-ons-popover
        cancelable
        :visible.sync="popoverVisible"
        :target="popoverTarget"
        :direction="popoverDirection"
        :cover-target="coverTarget"
      >
        <p v-html="popoverContent"></p>
      </v-ons-popover>
    </v-card>

    <h3 class="copy">Copyright © 2020. Todos os direitos reservados a Cyma Digital. <a class="copy" href="https://qrservice.com.br/termos-de-uso" target="_blank">Leia aqui os Termos e Condições.</a></h3>

  </v-ons-page>
</template>

<style scoped>
#FuncionalidadesPage {
  margin-left: 256px;
}

#FuncionalidadesPage span {
  text-transform: none;
  font-size: 1rem;
  color: #666666;
}

#FuncionalidadesPage .row {
  width: 50vw;
}

.copy {
  color: #666666;
  font-size: 0.8rem;
  font-family: "DMSans-Regular" !important;
  text-align: center;
  text-transform: none;
}

ons-row {
  width: 80%;
  margin: 20px auto;
}
ons-input {
  background-color: #fff;
  width: 15vw;
  border-radius: 5px;
  padding: 5px;
}
textarea {
  width: 80%;
  margin-top: 30px;
  background: #fff;
}
label {
  color: #999;
}
.left {
  text-align: left;
}
.right {
  text-align: right;
}
.linkChat {
  background-color: white;
  padding: 5px;
  border-radius: 5px;
  color: black;
  margin-right: 15px;
  font-size: 15px;
}
.fullWidthRow {
  width: 100%;
}
.conteudo-centro {
  justify-content: center;
}
hr {
  max-width: 80%;
  margin: 0 auto;
  border-width: 1px;
  border-top: 0px;
  border-color: lightgray;
}
.img-selo {
  /* width="auto" height="150vh" style="display: block; margin-bottom: 10px" */
  width: auto;
  height: 90px;
  display: block;
  margin-bottom: 10px;
}

.containerSwitch {
  max-width: 200px; 
  max-height: 50px;
  padding: 0px;
  padding-bottom: 12px;
}

@media (max-width: 1280px)
{
  .containerSwitch {
    padding: 0px 13px 12px 0;
  }
}
</style>

<script>
export default {
  name: "Funcionalidades",
  key: "Funcionalidades",
  props: ["pageStack"],
  data() {
    return {
      popoverVisible: false,
      popoverTarget: null,
      popoverDirection: "right",
      internoLink: "https://qrservice.com.br/",
      coverTarget: false,
      popoverContent: "",
      qrCodePedidos: "",
      e: {},
      lousaEditable:""
    };
  },

  mounted() {
    var estab = localStorage.getItem("e");
    this.e = JSON.parse(estab);

    // this.e = this.$root.$children[0]._data.e;
    if (this.e.txLousa != null) { 
      this.lousaEditable = this.e.txLousa
    }
    this.internoLink =
      "https://interno.qrservice.com.br/m/" + btoa(this.e.idEstabelecimento);
    this.qrCodePedidos =
      this.$menu_uri + "/gen-qr-pedidos/" + this.e.idEstabelecimento;
  },
  methods: {
    updateLousa(e) { 
      
      this.e.txLousa = e.target.innerText;
    },
    openCardapio() {
      var w = window.open(
        this.$menu_base + "p/" + btoa(this.e.idEstabelecimento),
        "_blank"
      );
      w.focus();
    },
    showPopover(event, content, coverTarget = false) {
      this.popoverTarget = event;
      this.popoverDirection = "right";
      this.coverTarget = coverTarget;
      this.popoverVisible = true;
      if (content == 0) {
        this.popoverContent =
          "1 - Cadastre sua senha <br><br> 2 - Use este link em qualquer aparelho com acesso a internet (copie e envie para quem for usar) <br><br> 3 - Ao entrar no link, faça o link com a senha. <br><br> 4 - Pronto! Cada solicitação aparecerá na tela ";
      }
      if (content == 1) {
        this.popoverContent =
          "Essa chave de acesso será a senha que seus funcionários irão acessar o aplicativo para visualizar os pedidos dos clientes.";
      }
    },
    saveLocal() {
      localStorage.setItem("e", JSON.stringify(this.e));
    },

    salvarEstab() {
      fetch(this.$menu_uri + "/save-funcoes", {
        method: "OPTIONS",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(this.e),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data === 1) {
            this.$ons.notification.toast(
              "As funções de sua loja foram atualizadas com sucesso.",
              { timeout: 1000, animation: "ascend" }
            );
            this.saveLocal();
          } else {
            this.$ons.notification.toast("Nenhuma alteração foi realizada.", {
              timeout: 1000,
              animation: "ascend",
            });
          }
        })
        .then((error) => {
          if (error) {
            this.$ons.notification.toast(
              "Ocorreu um erro ao salvar, tente novamente.",
              { timeout: 1000, animation: "ascend" }
            );
          }
        });
    },
  },

  watch: { 
    e: function(newE) { 
      var obj = Object.keys(newE)
      obj.forEach(el => {
        if (el.substring(0,2) == "fl") { 
          // window.console.log(el +" "+this.e[el])
          this.e[el] = this.e[el] == "1" ? true: false
        }
      });
    }
  
  }
};
</script>